import c from 'classnames';

import { Typography } from '@repo/ui';

import styles from './UserMessage.module.scss';

interface UserMessageProps {
  message: string;
  className?: string;
}

export const UserMessage = ({ message, className }: UserMessageProps) => {
  return (
    <div className={c(styles.userMessage, className)}>
      <Typography variant='body-s'>{message}</Typography>
    </div>
  );
};
